import { inject, injectable } from "inversify";
import { DIMixins } from "@/core/@types/types";
import type { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";
import { IF360Validator } from "@/core/validators/F360Validator";
import "reflect-metadata";

const FEATURE_FLAG_ADMIN_GROUPS = ["Developer", "Admin"];

@injectable()
export default class FeatureFlagAdminValidator implements IF360Validator {
  @inject(DIMixins.USER_PROFILE_STORAGE)
  private userProfileMixin!: IUserProfileStorageMixin;

  handleValidation(): boolean {
    const profile = this.userProfileMixin.handleGetUserProfile();
    const grupoDeUsuarios = profile?.AdminRoles?.GrupoDeUsuarios;

    return FEATURE_FLAG_ADMIN_GROUPS.includes(grupoDeUsuarios || "");
  }
}
